import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/feather/Download.svg?react
const SvgDownload = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M7 10L12 15M12 15L17 10M12 15L12 3M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/DownloadIcon.tsx
function DownloadIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgDownload,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { DownloadIcon as t };
//# sourceMappingURL=DownloadIcon-ExifwtX5.js.map